<template>
  <div v-if="initStatus === 1">
    <v-flex xs12 v-if="this.$route.name !== 'qClaimPayment'">
      <v-stepper :value="claimLifeCycle" class="ma-0 pa-0">
        <v-stepper-header non-linear class="ma-0 pa-0">
          <template v-if="claimLifeCycle <= 0">
            <v-stepper-step step="0" :complete="claimLifeCycle > 0">Register</v-stepper-step>
            <v-divider></v-divider>
          </template>
          <v-stepper-step step="1" editable @click.native="changeStep(2)">Claim Header</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" editable @click.native="changeStep(3)">Claimant</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" editable @click.native="changeStep(4)">Item</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4" editable @click.native="changeStep(5)">Reserve</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="5">Payment</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items class="ma-0 pa-0">
          <v-flex xs12 order-xs2 order-lg1 v-if="this.commonInfo.clmNo !== undefined">
            <v-sheet style="background-color: #00acc1ff" elevation="2">
              <v-card-text class="pt-3">
                <v-flex xs12 class="text-xs-left">
                  <span style="color: white">
                    <span class="toolbar-title-1">{{ this.commonInfo.clmNo }} - {{ this.commonInfo.insdName1 }}</span>
                  </span>
                </v-flex>
              </v-card-text>
            </v-sheet>
          </v-flex>
          <v-flex xs12 order-xs2 order-lg1>
            <v-card class="ma-0 pa-0">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 order-xs2 order-lg1>
                    <router-view></router-view>
                    <promptLeave title="Claim" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></promptLeave>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
    <transition v-else name="slide-x-transition" mode="out-in">
      <v-flex lg12 xs12 order-lg1>
        <router-view></router-view>
      </v-flex>
    </transition>
  </div>
  <loader
    v-else
    :card="false"
    :height="425"
    :init="doInit"
    loadText="Loading Claim Details..."
    errorText="Failed to load Claim Details"
    :loading="initStatus === 0"
  ></loader>
</template>

<script>
import { leaveClaim } from './leaveClaim'
import PromptLeave from './leaveClaim/PromptLeave'
import { CLAIMS_LIFECYCLE } from '@/store/types'

export default {
  data() {
    return {
      showPrompt: false
    }
  },
  computed: {
    initStatus() {
      return this.$store.state.claims.claimRegister.init
    },
    claimLifeCycle() {
      return this.$store.state.claims.claimDetail.claimLifeCycle - 1
    },
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    commonDispatch() {
      return this.$store.state.commons.dispatch
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('claimsRegisterInit')
    },
    changeStep(step) {
      if (step === 2) {
        this.$store.commit(CLAIMS_LIFECYCLE, 2)
        this.$router.push({ name: 'claimHeader', params: { navFlag: 1 } })
      } else if (step === 3) {
        this.$store.commit(CLAIMS_LIFECYCLE, 3)
        this.$router.push({ name: 'claimClaimant', params: { navFlag: 1 } })
      } else if (step === 4) {
        this.$store.commit(CLAIMS_LIFECYCLE, 4)
        this.$router.push({ name: 'claimItem', params: { navFlag: 1 } })
      } else if (step === 5) {
        this.$store.commit(CLAIMS_LIFECYCLE, 5)
        this.$router.push({ name: 'claimReserve', params: { navFlag: 1 } })
      }
    },
    setCommonDispatch() {
      if (this.commonDispatch.key === 'ReviewClaim' || this.commonDispatch.key === 'QueryClaim') {
        this.showPrompt = false
      } else {
        this.showPrompt = true
      }
    }
  },
  mounted() {
    if (this.initStatus !== 1) {
      this.doInit()
    }
  },
  components: {
    PromptLeave
  },
  mixins: [leaveClaim]
}
</script>

<style lang="scss">
</style>
